import { render, staticRenderFns } from "./cash.vue?vue&type=template&id=4b135154&scoped=true&"
import script from "./cash.vue?vue&type=script&lang=js&"
export * from "./cash.vue?vue&type=script&lang=js&"
import style0 from "./cash.vue?vue&type=style&index=0&id=4b135154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b135154",
  null
  
)

export default component.exports